export default "__VITE_ASSET__9gNEBE0s__"